import React from "react";

function IndustriesSection() {
  const industries = [
    {
      name: "IT & Software",
      icon: "/assets/icons/technical-support.png", 
    },
    {
      name: "E-commerce",
      icon: "/assets/icons/ecommerce.png", 
    },
    {
      name: "Real Estate",
      icon: "/assets/icons/contract.png", 
    },
    {
      name: "Fashion",
      icon: "/assets/icons/consumption.png",
    },
    {
      name: "Media",
      icon: "/assets/icons/bullhorn.png", 
    },
  ];

  return (
    <section className="py-16 bg-gradient-to-b from-gray-100 to-white">
      <div className="max-w-7xl mx-auto px-6 text-center">
        <h2 className="text-4xl font-extrabold text-primary mb-6">
          Industries We Operate In
        </h2>
        <p className="text-lg text-gray-600 mb-12">
          Driving innovation and growth across diverse sectors.
        </p>
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-6">
          {industries.map((industry, index) => (
            <div
              key={index}
              className="flex flex-col items-center bg-white p-6 rounded-lg shadow-md hover:shadow-lg hover:scale-105 transition-transform"
            >
              <img
                src={industry.icon}
                alt={`${industry.name} Icon`}
                className="w-12 h-12 mb-4"
              />
              <span className="text-lg font-semibold text-gray-800">
                {industry.name}
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default IndustriesSection;
